import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogCompassComponent } from '../dialogs/dialog-compass/dialog-compass.component';
import { DialogProficiencyComponent } from '../dialogs/dialog-proficiency/dialog-proficiency.component';

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.css'],
    standalone: false
})
export class OverviewComponent implements OnInit  {

  constructor(public dialog: MatDialog ) {}

  ngOnInit(): void {
    document.getElementsByTagName('mat-sidenav-content')[0]?.scrollTo(0, 0);
  }

  openProficiencyDialog() {
    this.dialog.open(DialogProficiencyComponent);
  }

  openCompassDialog() {
    this.dialog.open(DialogCompassComponent);
  }

}
